import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { StyleSheet } from 'react-native';
import { theme } from '@xbto/design-system';
import { Surface } from '../../atoms';
import { Callout } from '../../molecules';
export const ErrorCallout = memo((props) => {
    return (_jsx(Surface, { variant: "tertiary", style: [$.container, { height: props.height }], children: _jsx(Callout, Object.assign({}, props, { small: true })) }));
});
const $ = StyleSheet.create({
    container: {
        borderWidth: 1,
        borderColor: theme.color.border.primary,
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
    },
});
